import React, { FC, memo, useCallback, useMemo } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppFieldBox } from 'components/appComponents';
import { SelectBox, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';

export type ContractorChangeType = {
  providerId: number | null;
};

type CustomerTaskProps = {
  value: number | null;
  storeContragent: DataSource;
  readOnly: boolean;
  onChange: (value: number | null) => void;
};

const CustomerTask: FC<CustomerTaskProps> = ({ value, readOnly, storeContragent, onChange }) => {
  const handleChange = useCallback(
    (e) => {
      if (e.itemData) {
        onChange(e.itemData.id);
      }
    },
    [onChange],
  );

  const searchExpr = useMemo(() => ['name', 'inn'], []);

  return (
    <>
      <AppFieldBox label="Поставщик" labelTop>
        <div className="d-flex align-center">
          <SelectBox
            stylingMode="underlined"
            style={{ width: '100%' }}
            readOnly={readOnly}
            placeholder="Выберите поставщика"
            mode="text"
            value={value}
            onItemClick={handleChange}
            searchMode="contains"
            searchExpr={searchExpr}
            searchEnabled
            displayExpr="name"
            dataSource={storeContragent}
          >
            <Validator>
              <RequiredRule message="Выберите поставщика" />
            </Validator>
          </SelectBox>
        </div>
      </AppFieldBox>
    </>
  );
};

export default memo(CustomerTask, (prevProps, nextProps) => {
  if (prevProps.value === nextProps.value && prevProps.onChange === nextProps.onChange) {
    return true;
  } else {
    return false;
  }
});
